import {Constants} from './gradeSchemaConstants'
import {GradeSchema} from '../../../model/apprenticeModuleGrade.model'

export function setGradeSchemas(gradeSchemas: GradeSchema[]) {
	return {
		type: Constants.SET_GRADE_SCHEMAS,
		payload: gradeSchemas
	} as const
}

